import authService from "../../Application/User/AuthService";
import themeHelper from "../../Application/Helper/ThemeHelper";

const currentEnv = process.env.NODE_ENV;

export default function DevTool() {
  const devToolStyle = {
    position: "fixed",
    right: "10px",
    bottom: "10px",
    zIndex: 100,
    backgroundColor: "white",
    padding: "5px",
    border: "1px solid black",
  };

  return (
    <div id="dev-tool" style={devToolStyle}>
      <IsLoggedIn />
      <ThemeSwitcher />
    </div>
  );
}

function IsLoggedIn() {
  const changeLogin = () => {
    const isAuth = !authService.isAuthenticated();
    authService.setAuthenticated(isAuth);
    window.location.reload();
  };
  return (
    <div>
      <span>is logged in</span>
      <input
        type="checkbox"
        onChange={changeLogin}
        checked={authService.isAuthenticated()}
      ></input>
    </div>
  );
}

function ThemeSwitcher() {
  function changeTheme(event) {
    themeHelper.setTheme(event.target.value);
    window.location.reload();
  }
  const currentTheme = themeHelper.getCurrentTheme();
  return (
    <div>
      <span>theme</span>
      <select onChange={changeTheme} value={currentTheme}>
        {themeHelper.getAvailableThemes().map((theme, index) => (
          <option key={index} value={theme}>
            {theme}
          </option>
        ))}
      </select>
    </div>
  );
}

export function EnvTool() {
  if (currentEnv === "production") {
    return "";
  }

  const color = currentEnv === "development" ? "lightblue" : "lightgray";
  const devToolStyle = {
    position: "fixed",
    padding: 0,
    left: "10px",
    bottom: "10px",
    backgroundColor: color,
    zIndex: 1200,
  };

  return <div style={devToolStyle}>{currentEnv}</div>;
}
